/**
 * Simple hook for WebSocket connection status
 * Uses the router's getState() method
 */

import { useState, useEffect } from 'react';
import { getRouter } from './connection';
import type { ConnectionState } from './inbound';

export interface WebSocketStatus {
    state: ConnectionState;
    isConnected: boolean;
    isDisconnected: boolean;
}

/**
 * Hook to get WebSocket connection status
 */
export function useWebSocketStatus(): WebSocketStatus {
    const [state, setState] = useState<ConnectionState>(() => {
        const router = getRouter();
        return router.getState();
    });

    useEffect(() => {
        const router = getRouter();
        
        // Get initial state
        setState(router.getState());

        // Subscribe to state changes
        const unsubscribe = router.onStateChange((newState: ConnectionState) => {
            setState(newState);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return {
        state,
        isConnected: state === 'connected',
        isDisconnected: state === 'disconnected',
    };
}
